// ▣▣▣▣▣▣▣▣▣▣ SIZE CHART
function mmToggleSizeChart() {
  const sizeChartFilter = document.querySelector(
    ".mm-product-size-chart-filter"
  );
  sizeChartFilter.classList.toggle("mm-active");
}

// ▣▣▣▣▣▣▣▣▣▣ ACCORDEONS
function mmAccordeonProduct(clickedElem) {
  const accordeons = document.querySelectorAll(
    ".mm-faq-product-question-header"
  );

  if (clickedElem.classList.contains("mm-active")) {
    clickedElem.classList.remove("mm-active");
  } else {
    accordeons.forEach(function (elem) {
      elem.classList.remove("mm-active");
    });
    clickedElem.classList.add("mm-active");
  }
}

// 🟣 Modifié par Camille VEAUX
function mmAccordeonProductMobile(clickedElem) {
  const accordeons = document.querySelectorAll(
    ".mm-faq-product-question-header"
  );

  if (clickedElem.classList.contains("mm-active")) {
    clickedElem.classList.remove("mm-active");
  } else {
    clickedElem.classList.add("mm-active");
  }
}
// 🟣 FIN

// ▣▣▣▣▣▣▣▣▣▣ QUANTITY
function mmChangeQtty(delta, inputId) {
  var input = document.getElementById(inputId);
  if (delta == "-1" && input.value == "1") {
  } else {
    var newValue = parseInt(input.value, 10) + parseInt(delta, 10);
    input.value = newValue;
  }
}

// ▣▣▣▣▣▣▣▣▣▣ STOCK
function updateStockDisplay(isAvailable) {
  const offStockDiv = document.getElementById("OffStock");
  const inStockDiv = document.getElementById("InStock");

  if (isAvailable) {
    inStockDiv.style.display = "flex";
    offStockDiv.style.display = "none";
  } else {
    offStockDiv.style.display = "flex";
    inStockDiv.style.display = "none";
  }
}

// ▣▣▣▣▣▣▣▣▣▣ VARIANT SELECTION
class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.cached = {};
    this.container = this.closest(".mm-section-product");
    this.addEventListener("change", this.onVariantChange.bind(this)); // Ajout de .bind(this)
  }

  // ▣▣▣▣▣▣▣▣▣▣ CARIANT CHANGE
  onVariantChange() {
    this.getSelectedOptions();
    this.getSelectedVariant();

    if (this.currentVariant) {
      this.variantFetch();
      this.updateOptionsStocks();

      // 🟣 MODIF CVE
      const isVariantAvailable = this.currentVariant.available;
      updateStockDisplay(isVariantAvailable); // Assurez-vous que cette fonction est définie ailleurs si vous l'utilisez
      // 🟣 FIN
    }
  }

  // ▣▣▣▣▣▣▣▣▣▣ SELECTED OPTIONS
  getSelectedOptions() {
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked'),
      (radio) => radio.value
    );
  }

  // ▣▣▣▣▣▣▣▣▣▣ VARIANT DATA
  // from Json
  getVariantJSON() {
    this.variantData = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    return this.variantData;
  }

  // ▣▣▣▣▣▣▣▣▣▣ SELECTED VARIANT
  //compare the currentVariant with the VARIANT DATA and return the variant if comparaison
  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
      if (findings) return variant;
    });
  }

  /**
   * Fetch variant data from the server and cache it.
   */
  variantFetch() {
    var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

    if (this.cached[variantUrl]) {
      this.renderVariantInfo(this.cached[variantUrl]);
      return;
    }

    fetch(variantUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.cached[variantUrl] = html;
        this.renderVariantInfo(html);
      })
      .catch((e) => {
        console.log("Erreur dans variantFetch :", e);
      });
  }

  // ▣▣▣▣▣▣▣▣▣▣ VARIANT INFO
  renderVariantInfo(html) {
    this.updateElementOuter("#product-form-variant-id", html);
    this.updateElementOuter(".mm-product-price", html);
    this.updateElementInner(".mm-product-subtitle", html);
    this.updateElementInner(".mm-product-sticky-cta-subtitle", html);
    this.updateElementClass(".mm-btn-primary", html);
    this.updateElementInner(".mm-btn-primary", html);
    this.updateElementInner(".mm-main-product-sticky-cta-container", html);
    this.updateElementInner(".form__label", html);
    this.updateElementOuter(".mm-product-medias", html);
    this.updateElementOuter("#zoomSplide", html);
    setTimeout(() => {
      startProductMediaSplides();
    }, "500");
  }

  // ▣▣▣▣▣▣▣▣▣▣ UPDATE ELEMENT
  updateElement(selector, html) {
    const destination = this.container.querySelector(selector);
    const source = html.querySelector(selector);
    if (source && destination) destination.innerHTML = source.innerHTML;
  }

  updateElementClass(selector, html) {
    this.container.querySelector(selector).classList =
      html.querySelector(selector).classList;
  }

  // ▣▣▣▣▣▣▣▣▣▣ UPDATE ELEMENT OUTTER
  updateElementOuter(selector, html) {
    const destinations = this.container.querySelectorAll(selector);
    const sources = html.querySelectorAll(selector);

    if (destinations.length !== sources.length) {
      console.warn(
        "Le nombre d'éléments trouvés ne correspond pas entre les sources et les destinations."
      );
      return;
    }

    destinations.forEach((destination, index) => {
      const source = sources[index];
      if (source && destination) {
        destination.outerHTML = source.outerHTML;
      }
    });
  }

  // ▣▣▣▣▣▣▣▣▣▣ UPDATE ELEMENT INNER
  updateElementInner(selector, html) {
    const destinations = this.container.querySelectorAll(selector);
    const sources = html.querySelectorAll(selector);

    if (destinations.length !== sources.length) {
      console.warn(
        "Le nombre d'éléments trouvés ne correspond pas entre les sources et les destinations."
      );
      return;
    }

    destinations.forEach((destination, index) => {
      const source = sources[index];
      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }
    });
  }

  // ▣▣▣▣▣▣▣▣▣▣ UPDATE STOCK
  updateOptionsStocks() {
    const JSONoptions = this.variantData;
    const optionsValues = document.querySelectorAll(
      ".mm-product-form-variant-values"
    );

    optionsValues.forEach((optionValues, index) => {
      let mainIndex = index;
      let optionIndex = index;
      let options = optionValues.querySelectorAll("input");

      options.forEach((option) => {
        let currentOptionTested = option;
        let valuesToTest = [];
        valuesToTest.push(option.value);
        optionsValues.forEach((optionValues, index) => {
          if (index != optionIndex) {
            let options = optionValues.querySelectorAll("input");
            options.forEach((option) => {
              if (option.checked) {
                valuesToTest.push(option.value);
              }
            });
          }
          if (index == optionsValues.length - 1) {
            if (this.checkIfAvailable(JSONoptions, valuesToTest) == false) {
              currentOptionTested.classList.add("mm-disabled");
            } else {
              currentOptionTested.classList.remove("mm-disabled");
            }
          }
        });
      });
    });
  }

  checkIfAvailable(JSONoptions, valuesToTest) {
    const valuesToTestSorted = valuesToTest.slice().sort();

    for (let option of JSONoptions) {
      let optionsSorted = option.options.slice().sort();

      if (
        optionsSorted.every((val, index) => val === valuesToTestSorted[index])
      ) {
        return option.available;
      }
    }
    return false;
  }
}

// ▣▣▣▣▣▣▣▣▣▣ SUBMIT SELECTED VARIANT
function cveSubmitSelectedVariantToCart(openCart = true) {
  const variantId = document.getElementById("product-form-variant-id").value;
  const quantity = document.getElementById("mmMainProductQuantity").value;
  mmSubmitProductForm(variantId, { quantity: quantity, openCart: openCart });
}

document.addEventListener("DOMContentLoaded", (event) => {
  var event = new Event("change");
  const variantSelector = document.querySelector("variant-selector");
  if (variantSelector) {
    variantSelector.dispatchEvent(event);
  }
});

customElements.define("variant-selector", VariantSelector);
